const MAX_SUGGESTIONS = 7;

export default {
  MAX_SUGGESTIONS,
};
